<script>
import { getStringByLimitWords, getNumberOfWords } from '@/utils';

export default {
  name: 'CollapseContent',
  props: {
    content: {
      type: String,
      default: '',
    },

    limit: {
      type: Number,
      default: 200,
    },
  },

  data() {
    return {
      isFull: false,
    };
  },

  computed: {
    isSeeMore() {
      return getNumberOfWords(this.content) > this.limit;
    },

    contentDisplay() {
      const html = this.content
        .replace(/(?:\r\n|\r|\n)/g, '<br />')
        .replaceAll('<br /><br />', '<br />');
      if (!this.isSeeMore) {
        return html;
      }
      const shotTxt = `${getStringByLimitWords(html || '', this.limit)}... `;

      const str = this.isFull ? html : shotTxt;
      return str;
    },
  },

  methods: {
    onClick() {
      this.isFull = !this.isFull;
    },
  },
};
</script>
<template>
  <div>
    <div v-if="isFull" v-html="contentDisplay"></div>
    <div v-else>
      <div v-html="contentDisplay"></div>
      <a
        v-if="isSeeMore"
        class="tw-cursor-pointer tw-text-purple-500 hover:tw-text-purple-800 !tw-no-underline tw-whitespace-nowrap"
        @click="onClick"
        >{{ isFull ? 'see less' : 'see more' }}</a
      >
    </div>
    <a
      v-if="isFull && isSeeMore"
      class="tw-cursor-pointer tw-text-purple-500 hover:tw-text-purple-800 !tw-no-underline tw-whitespace-nowrap"
      @click="onClick"
      >{{ isFull ? 'see less' : 'see more' }}</a
    >
  </div>
</template>
